module.exports = __webpack_public_path__ + "static/media/P99_RADIO.520553f0.png";